import {ProvisionStatementStatus} from './provision-statement-status.enum';

/** German presentation companion of {@link ProvisionStatementStatus}, keyed by enum member. */
export const CP_STATEMENT_STATUS_LABELS: Readonly<Record<ProvisionStatementStatus, string>> = {
    [ProvisionStatementStatus.ACTIVE]: 'Gültig',
    [ProvisionStatementStatus.SUPERSEDED]: 'Ersetzt'
};

/** PrimeNG `p-tag` severities, mirroring the label map one-to-one. */
export const CP_STATEMENT_STATUS_SEVERITIES: Readonly<Record<ProvisionStatementStatus, 'success' | 'secondary'>> = {
    [ProvisionStatementStatus.ACTIVE]: 'success',
    [ProvisionStatementStatus.SUPERSEDED]: 'secondary'
};
